.chartsPageContainer {
  padding: 2rem;
  width: 100%;
  height: 100%;
  gap: 1rem;
}

.chartsContainer {
  gap: 1rem;
}